//文字自适应

//使用方式  $('body').fontFlex(20, 60, 20);
$.fn.fontFlex = function (min, max, mid) {

    var $this = this;

    $(window).resize(function () {

        var size = window.innerWidth / mid;

        if (size < min) size = min;
        if (size > max) size = max;

        $this.css('font-size', size + 'px');

    }).trigger('resize');
};





//导航悬浮顶部

//使用方法  $('.layui-header').$scrollH('.layui-header',"headbg",0,0);

//$classname=>指定dom名称
//$scrollname=>事件触发时想要增加的dom名称
//$scroll  滚动条下滑时候隐藏，上滑时候显示  0为关闭 1为开启
//$istop   元素是否是自身就是顶部元素  0为顶部元素 1不是顶部元素 （顶部元素(比如 <header> 就是顶部元素) 和其他元素的计算方式不同）
$.fn.$scrollH = function ($classname, $scrollname, $scroll, $istop, $Newname) {

    if ($(this).length > 0) {//如果这个元素存在

        var is_on = $($classname).is('.' + $scrollname);
        var scrollH = $(window).scrollTop();

        if ($istop == 1) {//不是顶部元素
            var header = $($classname).offset().top + $($classname).height();
        } else {//顶部元素
            var header = $($classname).height();
        }

        var heighT = header - scrollH;
        if (heighT < 0) {
            $($classname).addClass($scrollname);
        } else {
            $($classname).removeClass($scrollname);
        }


        $(window).scroll(function () {//高度变化时执行

            var is_on = $($classname).is('.' + $scrollname);
            var scrollH = $(window).scrollTop();

            if ($istop == 1) {//不是顶部元素
                var header = $($classname).offset().top + $($classname).height();
            } else {//顶部元素
                var header = $($classname).height();
            }

            var heighT = header - scrollH;

            if (heighT < 0) {
                $($classname).addClass($scrollname);
            } else {
                $($classname).removeClass($scrollname);
            }

        });



        if ($scroll == '1') {

            //导航整体下拉隐藏，上拉显示
            var before = $(document).scrollTop();
            //滚动事件
            $(document).scroll(function () {
                var after = $(window).scrollTop();
                if (after > before && after > 300) {
                    $($classname).addClass($Newname);
                } else {
                    $($classname).removeClass($Newname);
                }

                before = after;

            });

        }
    }
};


//点击事件

//$OtherThis   点击显示 再点击隐藏      0为关闭      1为开启
//$bodyclick   点击地方隐藏自身         0为关闭      1为开启
//$usother     给自身切换，或给子类切换  0为给自身    1为给子类  2为 点击显示 再点击隐藏
//$on          是触发条件，             click 点击   hover触摸
//$BoxClass    需要切换的标题元素
//$ToggleClass 关联切换的内容元素        子类切换 比如是多个li  则填写li的上一级ul
//$BtnClass    按钮切换的外层div元素

//切换上一页的div 一定要prev命名
//切换下一页的div 一定要next命名

//示例  $('.about').$toclick_hover(0,0,1,"hover","$boxul li",".toggle",".boxbtn");

$.fn.$toclick_hover = function (data) {
    let { $OtherThis, $bodyclick, $usother, $on, $BoxClass, $ToggleClass, $BtnClass, $needActive } = data;

    let add = true;

    // console.log(data);

    if ($(this).length > 0) {//如果页面存在这个元素执行

        //定义容器
        var boxul = $($BoxClass).parent();//指向box里 li的上级， 这里是指向了 box 下的 ul
        var boxli = $($BoxClass);         //指向box的 li

        //如果有关联内容
        if ($ToggleClass) {
            var ToggleClass = $($ToggleClass);
        }
        //当绑定为click点击切换效果
        if ($on == 'click') {
            //定义触发事件
            boxli.on("click", function (e) {//click点击
                if ($usother == '0') {//给自身切换
                    if ($OtherThis == '0') {
                        boxli.addClass('active');

                        if ($ToggleClass) {   //如果有关联内容
                            ToggleClass.addClass("active");
                        }
                    }
                    if ($OtherThis == '1') {
                        boxli.toggleClass('active');
                        if ($ToggleClass) {   //如果有关联内容
                            ToggleClass.toggleClass("active");
                        }
                    }

                    if ($bodyclick == '1') {
                        var is_on = $(this).is(".active");
                        if (is_on) {
                            $(document).on("click", function (e) {
                                var target = $(e.target);
                                if (target.closest(boxli).length == 0 && target.closest(ToggleClass).length != 1) {
                                    boxli.removeClass("active");
                                    if ($ToggleClass) {   //如果有关联内容
                                        ToggleClass.removeClass("active");
                                    }
                                };
                                e.stopPropagation();
                            })
                        }
                    }

                    if ($bodyclick == '2') {
                        var is_on = $(this).is(".active");
                        if (is_on) {
                            $(document).on("click", function (e) {
                                var target = $(e.target);

                                if ($ToggleClass) {   //如果有关联内容
                                    if (target.closest(ToggleClass).length == 0) {
                                        ToggleClass.removeClass("active");
                                    };

                                }
                                e.stopPropagation();
                            })
                        }
                    }
                }

                if ($usother == '1') {//给子类切换
                    let go = false;
                    if ($needActive) {
                        go = $(this).children('.sortname').eq(0).attr('data-dontgo')

                    }
                    if (!go) {
                        //点击当前元素添加active，同层次元素去除active
                        $(this).addClass("active").siblings().removeClass('active');

                        if ($ToggleClass) {   //如果有关联内容

                            console.log($(this));
                            ToggleClass.children().eq($(this).index()).addClass("active").siblings().removeClass("active");
                        }
                    }

                }


                if ($usother == '2') {//给子类切换

                    //点击当前元素添加active，同层次元素去除active
                    if ($(this).is(".active") == true) {
                        boxli.removeClass("active");
                    } else {
                        //boxli.eq($(this).index())
                        $(this).addClass("active").siblings().removeClass('active');
                    }


                    if ($ToggleClass) {   //如果有关联内容
                        ToggleClass.children().eq($(this).index()).addClass("active").siblings().removeClass("active");
                    }

                }


            });

        }

        //当绑定为hover触摸切换效果
        if ($on == 'hover') {
          
            //定义触发事件
            boxli.hover(function () {//hover
                if ($usother == '0') {//给自身切换

                    boxli.toggleClass('active');
                    if ($ToggleClass) {   //如果有关联内容
                        ToggleClass.toggleClass("active");
                    }

                }

                if ($usother == '1') {//给子类切换 
                    $(this).siblings().removeClass('active')
                    $(this).addClass("active")
                    //点击当前元素添加active，同层次元素去除active
                    // boxli.eq($(this).index()).addClass("active").siblings().removeClass('active');
                    console.log("$ToggleClass==========",$ToggleClass)        
                    if ($ToggleClass) {   //如果有关联内容
                        let curChildDom = ToggleClass.children().eq($(this).index())
                        console.log(curChildDom)
                        console.log(ToggleClass.children())
                        console.log($(this).index())
                        curChildDom.siblings().removeClass("active")
                        curChildDom.addClass("active")
                        // ToggleClass.children().eq($(this).index()).addClass("active").siblings().removeClass("active");
                    }

                }


            });

        }

        //如果存在按钮元素
        if ($BtnClass) {

            var prev = $($BtnClass).children('.prev');
            var next = $($BtnClass).children('.next');

            //点击切换到上一个选项卡
            prev.on("click", function (e) {

                $(boxul.find(".active")).prev("li").addClass("active").siblings().removeClass('active');
                ToggleClass.children().eq($(boxul.find(".active")).index()).addClass("active").siblings().removeClass("active");

            })

            //点击切换到下一个选项卡
            next.on("click", function (e) {
                $(boxul.find(".active")).next("li").addClass("active").siblings().removeClass('active');
                ToggleClass.children().eq($(boxul.find(".active")).index()).addClass("active").siblings().removeClass("active");
            })

        }

    }

    return false;
};




//视频点击封面播放

//使用方法  $('.layui-header').$video('.layui-header',"headbg",1,0);

//$classvideo=>指定播放按钮外层dom名称, $videobtn=>播放按钮dom名称，thisvideo=>视频video dom元素，videonum=>是否需要播放时的控件 为1时触发，videoloop=>视频是否循环，循环后不触发bind事件，因为一直在播放状态
$.fn.$video = function (classvideo, videobtn, thisvideo, videonum, videoloop) {

    if ($(this).length > 0) {

        $(videobtn).on("click", function (e) {

            var videourl = $(classvideo).attr('url');//获取视频地址
            $(thisvideo).attr('src', videourl);//赋值给video视频地址

            $(classvideo).addClass("active");
            $(thisvideo)[0].play();
            if (videonum == 1) {
                $(thisvideo).attr("controls", " ");
            }
            if (videoloop == 1) {
                $(thisvideo).attr("loop", "");
            }

            //播放完成加载文字图片
            $(thisvideo).bind("ended", function () {
                $(classvideo).removeClass('active');
            });
        });
    }

};


//方向感知鼠标移入移出
//$box是hover层   鼠标移到$box触发
//$toggle 是隐藏层  鼠标hover触发后 显示  隐藏层一定是hover层的子元素
//<li>
//  <div class="box">
//  </div>
//  <div class="toggle">
//  </div>
//</li>
//示例： $('li').$imghover('li .box','.toggle');   ps. 不是li .toggle  是直接写子类.toggle
$.fn.$imghover = function ($box, $toggle) {
    if ($(this).length > 0) {

        var $li = $($box);
        $li.hover(function (ev) {
            move.call(this, ev, true);
        }, function (ev) {
            move.call(this, ev, false);
        });
        function move(ev, bool) {
            var thisW = $(this).width();
            var thisH = $(this).height();
            var top = $(this).offset().top;
            var bottom = top + $(this).height();
            var left = $(this).offset().left;
            var right = left + $(this).width();
            var x = ev.pageX,
                y = ev.pageY;
            var sT = Math.abs(y - top),
                sB = Math.abs(y - bottom),
                sL = Math.abs(x - left),
                sR = Math.abs(x - right);
            var a = Math.min(sT, sB, sL, sR);
            switch (a) {
                case sT:
                    if (bool) {
                        $(this).find($toggle).css({
                            left: 0,
                            top: '-100%'
                        }).animate({
                            top: 0
                        }, 200);
                    } else {
                        $(this).find($toggle).stop(1, 1).animate({
                            top: '-100%'
                        }, 200);
                    }
                    break;
                case sB:
                    if (bool) {
                        $(this).find($toggle).css({
                            left: 0,
                            top: '100%'
                        }).animate({
                            top: 0
                        }, 200);
                    } else {
                        $(this).find($toggle).stop(1, 1).animate({
                            top: '100%'
                        }, 200);
                    }
                    break;
                case sL:
                    if (bool) {
                        $(this).find($toggle).css({
                            left: '-100%',
                            top: 0
                        }).animate({
                            left: 0
                        }, 200);
                    } else {
                        $(this).find($toggle).stop(1, 1).animate({
                            left: '-100%'
                        }, 200);
                    }
                    break;
                case sR:
                    if (bool) {
                        $(this).find($toggle).css({
                            left: '100%',
                            top: 0
                        }).animate({
                            left: 0
                        }, 200);
                    } else {
                        $(this).find($toggle).stop(1, 1).animate({
                            left: '100%'
                        }, 200);
                    }
                    break;
            }
        };
    };

};


//图片弹出层

//点击图片上层，弹出图片层
// name值就是.box,会自动查下级元素img的src值
//示例： $('.box').$imgbox('.box',1);
//<div class="box">
//    <a href="" pic=""></a>      如果imgsrc=1，则寻找img图片的上一级 标签pic获取图片
//    <img src="">                如果imgsrc=0或者不写，则寻找img获取图片
//</div>
$.fn.$imgbox = function (name, imgsrc) {

    if ($(this).length > 0) {

        if ($('.otherimg').length < 1) {
            $('body').append('<div class="otherimg"><img src=""></div>');
        }

        $(name).on("click", function (e) {

            if (imgsrc == 1) {
                var imgurl = $(this).find("img").parent().attr("pic");
            } else {
                var imgurl = $(this).find("img").attr("src");
            }
            $('.otherimg').toggleClass('on');
            $(".otherimg img").attr("src", imgurl);
        });
        $(".otherimg").on("click", function (e) {
            $(".otherimg img").attr("src", '');
            $('.otherimg').removeClass('on');
        });

    }
    console.log(2)
};



//文字弹出层

//点击元素，弹出文字层，
// name值就是.box,会自动查下级元素img的src值
//JQ示例：
//    $('.update-info-t2').$fix_textbox({
//       classname:"update-info-t2",                // 外层 元素
//       textname:"update-log ",                    // 隐藏文字层 元素
//       clickname:"active",                        // 点击 添加的样式
//       titlename:"更新日志",                       // 标题
//       closename:"fix-t-close",                   // 关闭按钮元素  可以为空
//       otherclick:1                               // 1为 开启 点击空白隐藏自身， 0或空时，不执行
//    });

//div示例：
//      <div class="update-info-t2">                //这个是外层元素  点击事件的触发者
//          <div class="update-log">123456</div>    //这个是隐藏层， 隐藏文字内容的   赋值给弹出层用的
//          <a class="btn">asd1</a>                 //这个随便写的 无所谓
//      </div>
$.fn.$fix_textbox = function (e) {
    return
    let { classname, textname, clickname, titlename, closename, otherclick } = e;

    if ($(this).length > 0) {

        _classname = $('.' + classname);
        _textname = $('.' + textname);
        _clickname = $('.' + clickname);
        _closename = $('.' + closename);




        if ($('.fix-textbox').length < 1) {
            $('body').append('<div class="fix-textbox"><div class="box"><div class="name fz28"></div><div class="text fz18"></div><div class="fix-t-close"></div></div></div>');
        }

        $(this).on("click", function (e) {

            if ($(this).is(".nolog")) {
                return false;
            }
            $('.fix-textbox .text').html($(this).find(_textname).html());
            $('.fix-textbox').addClass(clickname);
            _classname.addClass(clickname);

            if (titlename) {
                $('.fix-textbox .name').html(titlename);
            }

        });

        if (otherclick == 1) {//开启 点击空白隐藏自身

            $('.fix-textbox').on("click", function (e) {

                if ($(e.target).closest(".fix-textbox .text").length == 0) {
                    $('.fix-textbox').removeClass(clickname);
                    _classname.removeClass(clickname);
                }
                e.stopPropagation();
            });

        } else {//如果不开启 点击空白隐藏自身，则需要第三方元素关闭 或者 自身点击关闭隐藏

            //如果存在关闭按钮（第三方元素）
            if (closename) {

                $(".fix-textbox ." + closename).on("click", function (e) {
                    $('.fix-textbox').removeClass(clickname);
                    _classname.removeClass(clickname);
                    setTimeout(function () {
                        $(".fix-textbox .text").html(' ');
                    }, 500)
                });

            } else {//点击自身 关闭自身

                $('.fix-textbox').on("click", function (e) {

                    $('.fix-textbox').removeClass(clickname);
                    _classname.removeClass(clickname);

                });


            }


        }





    }

};



//视频列表遮罩层点击播放

//点击列表内任意视频，弹出遮罩层自动播放
// listname值就是视频列表层，如果一个页面所有页面都需要，可以选最外层元素
// videobox值就是列表的子元素，
//示例： $('.box').$video_play('body',".box");
//<div class="box" src="">
//    <video muted></video>
//</div>
//苹果端 videobox 需要 cursor:pointer
$.fn.$video_play = function ($listname, videobox) {

    var thisvideo = $($listname).find(videobox);

    if (thisvideo.length > 0) {//如果列表存在视频

        // $('body').append('<div class="otherimg posvideo"><video src="" controls autoplay muted><source src=""></source></video></div>');
        $('body').append('<div class="otherimg posvideo"><iframe   width="960" height="540" src="" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="false"> </iframe></div>');


        //player.bilibili.com/player.html?aid=942084535&bvid=BV1QW4y1h79b&cid=804606014&page=1

        // <iframe width="1440" height="762" src="https://www.youtube-nocookie.com/embed/7cjVj1ZyzyE" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>

        $(videobox).on("click", function (e) {

            // $('.otherimg').toggleClass('on');

            var video_url = $(this).attr("src");
            // var video = $(this).find("video");
            var video = $(this).find("iframe");

            if (video_url.length > 0) {//如果获得到视频地址
                //video.attr("src",video_url);
                // $(".otherimg video").attr('src', video_url);
                // $(".otherimg source").attr('src', video_url);

                $(".otherimg iframe").attr('src', video_url);

                setTimeout(function () {
                    $('.otherimg').addClass('on');
                    // $(".otherimg video")[0].play();
                }, 200);

                // if ($(".posvideo video")[0].play()) {

                //     $(".posvideo video").on("click", function (e) {
                //         $(".posvideo video")[0].pause()
                //     });

                // };
            }

        });


        $(".posvideo").on("click", function (e) {
            $(this).find('iframe').attr("src", '');
            $(this).find('video').attr("src", '');
            $(this).find('source').attr("src", '');
            $(this).removeClass('on');
        });
    };

};




//自动吸顶

// 滚动页面到此元素时， 此元素固定，没到此元素 在原尺寸不动
//$classname = 外层元素的名称
//$fixdiv = 需要进行吸顶元素的名称
//$todiv = 参考对应的元素 一般是旁边的固定元素

//示例：
//$('.auto_fixed').$auto_fixed({
//     menu_name:"header",
//     autoname:".auto_fixed",
//    fixname:".auto_div",
//    toname:".to_fix_div"
//});

//<div class="auto_fixed" >
//    <div  class="auto_div" >这个元素需要吸顶</div>
//    <div  class="to_fix_div" > 固定元素</div>
//</div>
// $.fn.$auto_fixed = function($classname,$fixdiv,$todiv) {
$.fn.$auto_fixed = function (e) {

    let { autoname, fixname, toname, menu_name } = e;

    if ($(this).length > 0) {//如果存在


        if ($(autoname).find(fixname).length > 0 && $(autoname).find(toname).length > 0) {//如果左右元素都存在

            function tofixed() {

                //滚动高度
                var scrollH = $(window).scrollTop();

                //获取导航栏目
                if ($(menu_name).length > 0) {
                    var menuH = $(menu_name).height();
                } else {
                    var menuH = 0;
                }

                //外层元素距离顶部的高度
                var fixdivTop = $(autoname).offset().top;

                //吸顶元素的高度
                var fixdivH = $(autoname).find(fixname).height();

                //固定元素的高度
                var todivH = $(autoname).find(toname).height();


                if (fixdivH < todivH) {//如果 固定元素高度 比 吸顶元素高度 高， 执行吸顶判断

                    var HNum = scrollH - fixdivTop + menuH;

                    if (HNum > 0) {
                        $(fixname).addClass('fixed_on');
                    } else {
                        $(fixname).removeClass('fixed_on');
                    }

                    var To_H = scrollH - todivH - fixdivTop + fixdivH + menuH;

                    if (To_H > 0) {//如果 滚动 将 吸顶元素 超过 固定元素
                        $(fixname).removeClass('fixed_on');
                    }









                }

            };

            tofixed();
            $(window).resize(function () {

                tofixed();

            }).trigger('resize');

            $(window).scroll(function () {
                tofixed();
            });


        }




    };

};